import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    standalone: false
})
export class MessageDialogComponent {
	mode: string;
	value: string;

	private signaturePadOptions: Object = {
		'minWidth': 5,
		'canvasWidth': 300,
		'canvasHeight': 250
	};

	constructor(
		public dialogRef: MatDialogRef<MessageDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any) {

		this.mode = this.data.mode || 'confirm';
		this.value = this.data.value;
	}

	clear() {
		delete this.value;
	}

	confirmPrompt(form) {
		if (form.valid) {
			this.dialogRef.close(this.value);
		}
	}


	drawStart() {
	}


}
